import React from "react";

import { useInsightsContext } from "../../Context/InsightsContext";
import { useDeskOverviewInsightsContext } from "../../Context/Desk/Overview/OverviewContext";
import { useDeskUtilizationInsightsContext } from "../../Context/Desk/Utilization/UtilizationContext";
import { useDeskBehaviourInsightsContextContext } from "../../Context/Desk/Behaviour/BehaviourContext";
import { InsightsLoaderModalController } from "./InsightsLoaderModalController";

interface Props {
  onCancel: () => void;
}

export const DeskInsightsLoaderModal = ({ onCancel }: Props) => {
  const { loadingGeneralSettings } = useInsightsContext();
  const {
    loadingOverview,
    loadingGeneral,
    loadingRange,
    loadingDeskHistory,
  } = useDeskOverviewInsightsContext();
  const { loadingOccupancy, loadingHeatmap } =
    useDeskUtilizationInsightsContext();
  const { loadingMeetings, loadingSankey } =
    useDeskBehaviourInsightsContextContext();

  const isLoading =
    loadingGeneralSettings ||
    loadingOverview ||
    loadingGeneral ||
    loadingRange ||
    loadingDeskHistory ||
    loadingOccupancy ||
    loadingHeatmap ||
    loadingMeetings ||
    loadingSankey;

  return (
    <InsightsLoaderModalController
      isLoading={isLoading}
      insightsType="desks"
      onCancel={onCancel}
    />
  );
};
